// DeepL official wordmark icon, sourced from www.deepl.com/img/logo/deepl-logo-blue.svg.
// Inlined so it can be sized/coloured via CSS without an extra HTTP request.
// Fills come from the --vendor-deepl tokens, which carry DeepL's own palette
// verbatim so the comparison feature keeps their official identity.

import React from 'react';
import { COLORS } from '../../theme/colors';

function DeepLLogo({ size = 16, className = '' }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 54 68"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="DeepL"
    >
      <path
        d="M0.1875 17.2741V44.0848C0.1875 45.4775 0.917813 46.7542 2.10938 47.4506L25.1719 60.8366C26.3634 61.533 27.8241 61.533 29.0156 60.8366L52.0781 47.4506C53.2697 46.7542 54 45.4775 54 44.0848V17.2741C54 15.8813 53.2697 14.6046 52.0781 13.9083L29.0156 0.522285C27.8241 -0.174095 26.3634 -0.174095 25.1719 0.522285L2.10938 13.947C0.917813 14.6433 0.1875 15.92 0.1875 17.2741Z"
        fill={COLORS.vendorDeepl}
      />
      <path
        d="M36.7031 67.5303L36.6647 61.7271L36.7031 56.3882L23.25 59.7153"
        fill={COLORS.vendorDeepl}
      />
      <path
        d="M36.0879 55.9238L38.6248 55.2661L37.6638 55.8077C37.0873 56.1559 36.7029 56.7749 36.7029 57.4713V58.5546L36.0879 55.9238Z"
        fill={COLORS.vendorDeeplShade}
      />
      <path
        d="M17.7904 18.4744C19.3279 16.9656 21.7879 16.9656 23.3254 18.4744C24.9782 20.0606 24.9782 22.6914 23.3254 24.2776C21.7879 25.7864 19.3279 25.7864 17.7904 24.2776C16.1376 22.6914 16.1376 20.0606 17.7904 18.4744Z"
        fill="white"
      />
      <path
        d="M35.0873 28.5716C36.6248 27.0627 39.0848 27.0627 40.6223 28.5716C42.2751 30.1578 42.2751 32.7885 40.6223 34.3747C39.0848 35.8836 36.6248 35.8836 35.0873 34.3747C33.4345 32.7885 33.4345 30.1578 35.0873 28.5716Z"
        fill="white"
      />
      <path
        d="M17.7904 39.2498C19.3279 37.741 21.7879 37.741 23.3254 39.2498C24.9782 40.836 24.9782 43.4668 23.3254 45.053C21.7879 46.5618 19.3279 46.5618 17.7904 45.053C16.1376 43.4668 16.1376 40.836 17.7904 39.2498Z"
        fill="white"
      />
      <path
        d="M22.4805 23.5419L34.0117 30.2349L35.9336 29.1516L24.4023 22.4199L22.4805 23.5419Z"
        fill="white"
      />
      <path
        d="M34.7805 35.1482L24.4023 41.1835L22.4805 40.0616L32.8586 34.0649L34.7805 35.1482Z"
        fill="white"
      />
    </svg>
  );
}

export default DeepLLogo;
